import "./styles.scss"

const Comments = ({ value, onChange, placeholder, rows = 4, disabled, maxLength, ...props }) => {
    return (
        <textarea
            className="inputs-comments"
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            rows={rows}
            disabled={disabled}
            maxLength={maxLength}
            {...props}
        />
    )
}

export default Comments